module.exports = __webpack_public_path__ + "files/SPIADI2019 - Abstract ECCMID.96a4b1053c8e149fcb68951de59c7a8d.pdf";